import client from '../../../apollo';
import { gql } from '@apollo/client'

export const SET_HOMEPAGE_PREFERENCE = 'SET_HOMEPAGE_PREFERENCE';
export const SET_HOMEPAGE_PREFERENCE_SUCCESS = 'SET_HOMEPAGE_PREFERENCE_SUCCESS';
export const SET_HOMEPAGE_PREFERENCE_FAIL = 'SET_HOMEPAGE_PREFERENCE_FAIL';

const initialState = {
  homePageOptIn: true,
  loading: false,
  loaded: true,
  error: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_HOMEPAGE_PREFERENCE:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case SET_HOMEPAGE_PREFERENCE_SUCCESS:
      return {
        ...state,
        homePageOptIn: action.data,
        loading: false,
        loaded: true
      };
    case SET_HOMEPAGE_PREFERENCE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error
      };
    default:
      return state;
  }
}

const setHomePageOptInQuery = gql`
  mutation setShowNewHomePage($showNewHomepage: Boolean!) {
    setPreferences(showNewHomepage: $showNewHomepage) {
      showNewHomepage
    }
  }
`;

export const actions = {};

actions.setHomePageOptIn = async function setHomePageOptIn(dispatch, homePageOptIn) {
  dispatch({ type: SET_HOMEPAGE_PREFERENCE });
  try {
    const response = await client.mutate({
      mutation: setHomePageOptInQuery,
      variables: { showNewHomepage: homePageOptIn }
    });
    dispatch({
      type: SET_HOMEPAGE_PREFERENCE_SUCCESS,
      data: response.data.setPreferences.showNewHomepage
    });
  } catch (error) {
    dispatch({
      type: SET_HOMEPAGE_PREFERENCE_FAIL,
      error: error.message
    });
  }
};
